module.exports = __webpack_public_path__ + "static/img/wspic.8b264df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/wspic.png
// module id = e4mS
// module chunks = 0